(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("lodash"), require("ua-parser-js"));
	else if(typeof define === 'function' && define.amd)
		define(["lodash", "ua-parser-js"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("lodash"), require("ua-parser-js")) : factory(root["_"], root["uaParser"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(self, function(__WEBPACK_EXTERNAL_MODULE_luq0__, __WEBPACK_EXTERNAL_MODULE_glLg__) {
return 